<script lang="ts">
	import type { Post } from '$lib/api/rpc';
	import Footer from '$lib/components/Post/PostBlock/Blocks/Footer.svelte';
	import { onMount } from 'svelte';
	export let block: Post;
	import { page } from '$app/stores';
	export let editable = false;

	var doc = new DOMParser().parseFromString(block.oembed?.html || '', 'text/xml');
	const iframeSrc = doc.firstElementChild?.getAttribute('src');
	let canPlay = false;
	let videoEl = document.createElement('video');
	onMount(() => {
		canPlay =
			['maybe', 'probably'].includes(videoEl.canPlayType(block.mime)) ||
			block.mime === 'video/quicktime';
	});
</script>

<div>
	<div class="video-container">
		{#if canPlay}
			<video
				poster={`${$page.data.apiUrl}${block.title_image?.url}`}
				src={`${$page.data.apiUrl}${block.file_path}`}
				class="video"
				autoplay={false}
				loop={false}
				muted={false}
				controls={true}>
				<track kind="captions" />
			</video>
		{:else}
			<iframe id="iframe" class="video" title="video" src={iframeSrc} allowfullscreen />
		{/if}
	</div>
	<svelte:element
		this={editable ? 'div' : 'a'}
		href={block.source.url}
		target="blank"
		rel="external">
		<Footer {editable} {block} />
	</svelte:element>
</div>

<style>
	.video-container {
		block-size: 360px;
	}

	img {
		block-size: 100%;
		inline-size: 100%;
		object-fit: cover;
	}

	.video {
		block-size: 100%;
		inline-size: 100%;
		object-fit: cover;
	}

	a {
		text-decoration: none;
	}
</style>
